import { render, staticRenderFns } from "./AddSupplierBSelf.vue?vue&type=template&id=e9b56670&scoped=true&"
import script from "./AddSupplierBSelf.vue?vue&type=script&lang=js&"
export * from "./AddSupplierBSelf.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierBSelf.vue?vue&type=style&index=0&id=e9b56670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b56670",
  null
  
)

export default component.exports